app.factory('pessoaFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {
    var _apiName = 'Pessoa';

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listBMPOnly = function (options) {
        var dto = options.data;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBMPOnly', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listPF = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListPF', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _saveBMPOnly = function (dto) {
        var method = 'UpdateBMPOnly';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    }

    var _saveRapido = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/InsertRapido', dto);
    };

    var _buscarPessoaPorDocumento = function (documento, empresa) {
        var dto = {};
        dto.Documento = documento;
        dto.CodigoEmpresa = empresa;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscarPessoaPorDocumento', dto);
    };

    var _buscarPessoaPorDocumentoSemBureauRestritivo = function (documento) {
        var dto = {};
        dto.id = documento;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscarPessoaPorDocumentoSemBureauRestritivo', dto);
    };


    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listClientePropostaPF = function (search) {
        var dto = {};
        dto.id = search;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListClientePropostaPF', dto);
    };

    var _listPessoaJuridica = function (search) {
        var dto = {};
        dto.id = search;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListPessoaJuridica', dto);
    };

    var _listPessoaJuridicaGrid = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListPessoaJuridicaGrid', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listPessoaRepresentante = function (search) {
        var dto = {};
        dto.id = search;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListPessoaRepresentante', dto);
    };

    var _listPessoaFundo = function (search) {
        var dto = {};
        dto.id = search;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListPessoaFundo', dto);
    };

    var _listEmpresasComAgendaPagamento = function () {

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListEmpresasComAgendaPagamento');
    };

    var _listParceiroUnidadeBMP = function () {

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListParceiroUnidadeBMP');
    };

    var _getPessoaPorCodigoRede = function (codigoRede) {
        var dto = {};
        dto.id = codigoRede;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GetPessoaPorCodigoRede', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.findRecord = _findRecord;
    factory.list = _list;
    factory.listBMPOnly = _listBMPOnly;
    factory.listPF = _listPF;
    factory.save = _save;
    factory.saveBMPOnly = _saveBMPOnly;
    factory.saveRapido = _saveRapido;
    factory.delete = _delete;
    factory.buscarPessoaPorDocumento = _buscarPessoaPorDocumento;
    factory.buscarPessoaPorDocumentoSemBureauRestritivo = _buscarPessoaPorDocumentoSemBureauRestritivo;
    factory.listClientePropostaPF = _listClientePropostaPF;
    factory.listPessoaJuridica = _listPessoaJuridica;
    factory.listPessoaJuridicaGrid = _listPessoaJuridicaGrid;
    factory.listPessoaRepresentante = _listPessoaRepresentante;
    factory.listPessoaFundo = _listPessoaFundo;
    factory.listEmpresasComAgendaPagamento = _listEmpresasComAgendaPagamento;
    factory.listParceiroUnidadeBMP = _listParceiroUnidadeBMP;
    factory.getPessoaPorCodigoRede = _getPessoaPorCodigoRede;

    return factory;

}]);
